import TripViewer from './TripViewer';
import withRole from '../../hocs/withRole';

export default [{
  path: '/tripviewer',
  exact: true,
  component: withRole(['Vehicle Admin', 'Client Admin', 'Client View'], TripViewer),
}];
